export const fileUploadOptions = {
  accept: ".png",
  maxFileSize: "1000K",
};

export const characterTableColumns = [
  {
    label: "Char ID",
    field: "id",
    type: "number",
  },
  {
    label: "Char Name",
    field: "name",
  },
  {
    label: "Char Description",
    field: "description",
  },
  {
    label: "Char Picture",
    field: "image_url",
    sortable: false,
  },
  {
    label: "Background",
    field: "background_url",
    sortable: false,
  },
  {
    label: "Num active questions",
    field: "num_active_question",
    type: "number",
  },
  {
    label: "Last Modified",
    field: "modified_time",
  },
  {
    label: "Modified By",
    field: "modified_by",
  },
];

export const questionTableColumns = [
  {
    label: "ID",
    field: "id",
    type: "number",
  },
  {
    label: "Name",
    field: "name",
  },
  {
    label: "Question",
    field: "text",
  },
  {
    label: "Char Name",
    field: "character_name",
  },
  {
    label: "Char Picture",
    field: "thumbnail",
  },
  {
    label: "Num choices",
    field: "num_choices",
    type: "number",
  },
  {
    label: "Status",
    field: "status",
  },
  {
    label: "Last Modified",
    field: "modified_time",
  },
  {
    label: "Modified By",
    field: "modified_by_username",
  },
];
